import { useRouteError } from 'react-router';
import { isHttpError } from '~/common/http/http-error';
import { TokenError } from '~/pages/Evaluator/TokenError';

export function TokenErrorBoundary() {
  const error = useRouteError();

  if (!isHttpError(error) || !error.hasErrorCode('INVITE_EXPIRED_OR_USED'))
    throw error;

  return <TokenError />;
}
